import React, { useEffect, useLayoutEffect, useState } from 'react';
import { createClient, AgoraVideoPlayer, createMicrophoneAndCameraTracks } from 'agora-rtc-react';
import Controls from '../AudioVideoCallComponent/Controls';
import Draggable from 'react-draggable';
import { FaMicrophoneSlash } from 'react-icons/fa6';
import { IoVideocamOffOutline } from 'react-icons/io5';
import { FaPlayCircle } from 'react-icons/fa';
import { MdOutlineOpenInFull } from 'react-icons/md';
import { useNavigate } from 'react-router-dom'
import styles from './Floating.module.scss'
import useAgoraUsers from 'hooks/useAgora'
import { useSelector, useDispatch } from 'react-redux'
import { actions as manageCallActions } from 'slices/manageCall.slice'

const config = { mode: 'rtc', codec: 'vp8' };
const useClient = createClient(config);
const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks()

const FloatingVideo = ({appId}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const client = useClient();
  // const [start, setStart] = useState(false);
  // const [localConnectionState, setLocalConnectionState] = useState({
  //   audio: true,
  //   video: true,
  // });
  const { ready, tracks } = useMicrophoneAndCameraTracks()
  const { manageCallData, callJoiningStatus } = useSelector((state) => state.callData)
  const { engageCall, callType, channelName, account } = manageCallData

  const {
    users,
    agoraInstance,
    time: timing,
    options: currentOption,
    initialNameLetters,
    remoteConnectionState,
  } = useAgoraUsers()

  useEffect(() => {
    console.log("callJoiningStatus ", callJoiningStatus)
  },[callJoiningStatus]);
  // const [user, setUsers] = useState([])
  const { nextMode } = useSelector(
    (state) => state.mentalHealth,
  )

  // const updateUsers = (newUsers) => {
  //   if (newUsers) {
  //     setUsers([...newUsers])
  //   }
  // }
  const setCallJoiningStatus = (status) => {
    dispatch(manageCallActions.setCallJoiningStatus(status))
  }
  
  const initializeAgora = async () => {
    if (manageCallData?.engageCall) {
      if(!agoraInstance.client) agoraInstance.client = client
      if(!agoraInstance.appId) agoraInstance.appId = appId
      if(!agoraInstance.channelName) agoraInstance.channelName = channelName
      if(!agoraInstance.token) agoraInstance.token = manageCallData?.token
      if(!agoraInstance.account) agoraInstance.account = account
      if(!agoraInstance?.tracks) agoraInstance.tracks = tracks
      agoraInstance.ready = ready
      await agoraInstance.init(channelName, setCallJoiningStatus)
    }
  }
  useEffect(() => {
    

    if (ready && tracks && !callJoiningStatus) {
      initializeAgora().catch((error) => {
        console.error('AGORRAAA Failed to initialize Agora:', error)
      });
    }
  }, [ ready, tracks, manageCallData, callJoiningStatus ])



  // useEffect(() => {
  //   // Stop the local video track and clean up when the call ends
  //   if (!start && tracks) {
  //     tracks.forEach((track) => {
  //       if (track) {
  //         track.stop();
  //         track.close();
  //       }
  //     });
  //     setUsers([]); // Clear users
  //   }
  // }, [start, tracks]);
  
  // useEffect(() => {
  //   setStart(agoraInstance.start);
  // }, [agoraInstance.start, agoraInstance.remoteConnectionState]);

  
  // useEffect(() => {
  //   if (start) {
  //     agoraInstance.addObserver('users', updateUsers)
  //   }
  // }, [initialNameLetters, tracks, ready, callStart])
  

  // useLayoutEffect(() => {
  //   // Manage call state
  //   setStart(ready && callStart);

  //   // Validate and update local track states
  //   if (tracks && tracks.length > 0) {
  //     const audioEnabled = tracks[0]?.enabled ?? false;
  //     const videoEnabled = tracks[1]?.enabled ?? false;

  //     setLocalConnectionState({ audio: audioEnabled, video: videoEnabled });
  //   } else {
  //     setLocalConnectionState({ audio: false, video: false });
  //   }
  // }, [ready, callStart, tracks, users]);

  // useEffect(() => {
  // }, [users, tracks]);

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <>
      {engageCall && (
        <div className={styles.callContainer}>
          {engageCall && tracks && ready && (
            <div className={styles.container}>
              {/* Call Info */}
              <div className={styles.assessment}>
                <span className={styles.tag}>{currentOption}</span>
                <span className={styles.timeTag}>{formatTime(timing)}</span>
                {!remoteConnectionState.audio && (
                  <FaMicrophoneSlash color="white" size={24} />
                )}
              </div>

              {/* Local Video */}
              <Draggable bounds="parent">
                <div className={styles.hostVideo}>
                  {tracks && tracks[1] ? (
                    <AgoraVideoPlayer
                      className={styles.video_frame}
                      videoTrack={tracks[1]}
                    />
                  ) : (
                    <div className={styles.video_frame_black}>
                      <IoVideocamOffOutline color="white" size={30} />
                      <span>Camera Off</span>
                    </div>
                  )}
                </div>
              </Draggable>

              {/* Up Next Section */}
              <div className={styles.listening}>
                <div className={styles.upNextWrapper}>
                  <FaPlayCircle color="white" size={15} />
                  <span className={styles.upNext}>Up next </span>
                </div>
                <span className={styles.planningBottomTag}>

                  {nextMode}
                </span>
              </div>

              {/* Navigation Button */}
              <div
                className={styles.route}
                onClick={() => navigate('/active-chats')}
              >
                <MdOutlineOpenInFull color="white" size={24} />
              </div>

              {/* Controls */}
              <div className={styles.controls}>
                <Controls
                  tracks={tracks}
                  // setStart={setStart}
                  id={channelName}
                  client={client}
                  type="videoCall"
                />
              </div>

              {/* Remote Video */}
              {users?.length > 0?  users.map((user) =>
                user.videoTrack ? (
                  remoteConnectionState.video ? (
                    <AgoraVideoPlayer
                      className={styles.video_frame_remote}
                      videoTrack={user.videoTrack}
                      key={user.uid}
                    />
                  ) : (
                    <div
                      className={styles.video_frame_black_remotee}
                      key={user.uid}
                    >
                      <IoVideocamOffOutline color="white" size={30} />
                      <span>{initialNameLetters || 'Camera Off'}</span>
                    </div>
                  )
                ) : (
                  <div
                    className={styles.video_frame_black_remotee}
                    key={user.uid}
                  >
                    <IoVideocamOffOutline color="white" size={30} />
                    <span>{initialNameLetters || 'No Video'}</span>
                  </div>
                ),
              ): <div
                className={styles.video_frame_black_remotee}
                >
              <IoVideocamOffOutline color="black" size={30} />
              <span>Ringing...</span>
            </div>
            }
            </div>
          )}
        </div>
      )}
    </>
  )
};

export default FloatingVideo;
